 <template>
  <div style="position: relative;">
    <VueGoogleAutocomplete
      v-if="displaySearchBox"
      :id="mapId + '_map_edit'"
      v-model="streetAddress"
      placeholder="Search Box"
      v-on:placechanged="getAddressData"
      @keypress="movePacContainer"
      style="
        background-color: #fff;
        padding: 0 11px 0 13px;
        width: 45%;
        position: absolute;
        top: 10px;
        left: 42%;
        z-index: 2;
      "></VueGoogleAutocomplete>
    <div ref="googleMap" class="google-map" :id="mapId"></div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from './../GoogleMap/VueGoogleAutocomplete.vue'
import { Helper } from './../../services'

export default {
  name: "GoogleMap",
  components: {
    VueGoogleAutocomplete
  },
  props: {
    mapId: {
      type: String,
      required: true,
    },
    streetAddress: {
      type: String,
      default: '',
    },
    draggableMarker: {
      type: Boolean,
      default: false,
    },
    displaySearchBox: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      map: null,
      marker: null,
      markerGeolocation: {
        latitude: 51.50578441622598,
        longitude: -0.1248144226074146,
      },
    }
  },
  async created() {
    var meGeolocation = await this.getUserPosition()
    if (this.latitude && this.longitude) {
      this.markerGeolocation.latitude = this.latitude
      this.markerGeolocation.longitude = this.longitude
    } else if (meGeolocation && this.draggableMarker) {
      this.markerGeolocation.latitude = meGeolocation.lat()
      this.markerGeolocation.longitude = meGeolocation.lng()
    }

    this.map = this.createMap()
    this.displayUserPosition(meGeolocation)
    this.marker = this.createMarker(this.markerGeolocation.latitude, this.markerGeolocation.longitude)
  },
  methods: {
    createMap() {
      const element = document.getElementById(this.mapId)
      const options = {
        zoom: 20,
        center: new google.maps.LatLng(this.markerGeolocation.latitude, this.markerGeolocation.longitude),
      }
      return new google.maps.Map(element, options)
    },
    createMarker(latitude, longitude) {
      const position = new google.maps.LatLng(latitude, longitude)
      return new google.maps.Marker({
        clickable: false,
        position: position,
        draggable: this.draggableMarker,
        animation: google.maps.Animation.DROP,
        map: this.map,
      })
    },
    focusOnMarker(latitude, longitude) {
      var bounds = new google.maps.LatLngBounds();
      bounds.extend(new google.maps.LatLng(latitude, longitude));
      this.map.fitBounds(bounds);

      this.map.setZoom(20);
    },
    async getUserPosition() {
      // get user geolocation
      var meGeolocation = null
      if (navigator.geolocation) {
        try {
          var mePosition = await Helper.getPosition()

          meGeolocation = new google.maps.LatLng(
            mePosition.coords.latitude,
            mePosition.coords.longitude
          )
        } catch (error) {
          console.error(error)
        }
      }

      return meGeolocation
    },
    displayUserPosition(meGeolocation) {
      if (meGeolocation) {
        var myloc = new google.maps.Marker({
          clickable: false,
          icon: new google.maps.MarkerImage(
            '//maps.gstatic.com/mapfiles/mobile/mobileimgs2.png',
            new google.maps.Size(22, 22),
            new google.maps.Point(0, 18),
            new google.maps.Point(11, 11)
          ),
          shadow: null,
          zIndex: 999,
          map: this.map,
        })
        myloc.setPosition(meGeolocation)

        return myloc
      }

      return null
    },
    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    getAddressData(addressData, placeResultData, id) {
      this.marker.setMap(null);
      this.marker = this.createMarker(addressData.latitude, addressData.longitude)
      this.focusOnMarker(addressData.latitude, addressData.longitude)
    },
    getPosition() {
      return {
        latitude: this.marker.position.lat(),
        longitude: this.marker.position.lng(),
      }
    },
    setPosition(latitude, longitude) {
      if (this.marker) {
        this.marker.setMap(null);
        this.marker = this.createMarker(latitude, longitude)
        this.focusOnMarker(latitude, longitude)
      } else {
        this.markerGeolocation.latitude = latitude
        this.markerGeolocation.longitude = longitude
      }
    },
    movePacContainer () {
      /*
      let searchBox = document.querySelector('#' + this.mapId + '_map_edit')

      let pacContainer = document.querySelector('.pac-container')
      pacContainer.style.width = '206px'
      pacContainer.style.left = '42%'
      pacContainer.style.top = '32px'

      searchBox.parentElement.appendChild(pacContainer)
      */
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/GoogleMap/VueGoogleMap.vue